module.exports = __webpack_public_path__ + "static/media/loc1_img18.8d90a37c.jpg";